import { SerializedStyles, css, keyframes } from '@emotion/react'
import { primary, transitionEasing } from '../styles/theme'

import React from 'react'

interface Props {
  color?: string
  extraCss?: SerializedStyles | SerializedStyles[]
}

export default function LoadingIcon({ color = primary, extraCss }: Props) {
  return (
    <svg css={[styles.icon, extraCss]} viewBox="0 0 25 25">
      <path
        css={styles.path}
        style={{ stroke: color }}
        d="M21.3976834,15.1988417 C22.3252659,15.1988417 23.0772201,14.4468875 23.0772201,13.519305 L23.0772201,5.12162162 C23.0772201,3.26645663 21.5733117,1.76254826 19.7181467,1.76254826 C19.3253764,1.76254826 18.9483509,1.82995969 18.5980089,1.95384384 C19.2559743,2.76694327 19.6659048,3.78808487 19.7134915,4.90305718 L19.7181467,5.12162162 L19.7181467,13.519305 C19.7181467,14.4468875 20.4701009,15.1988417 21.3976834,15.1988417 Z M14.6795367,1.76254826 C12.8243717,1.76254826 11.3204633,3.26645663 11.3204633,5.12162162 L11.3204633,16.8783784 C11.3204633,18.078514 10.9008728,19.180649 10.2003861,20.046089 C10.549948,20.1699116 10.9273183,20.2374517 11.3204633,20.2374517 C13.1756283,20.2374517 14.6795367,18.7335434 14.6795367,16.8783784 L14.6795367,5.12162162 C14.6795367,3.92148597 15.0991272,2.81935095 15.7996139,1.95391097 C15.4495869,1.8300052 15.0724395,1.76254826 14.6795367,1.76254826 Z M18.03861,5.12162162 C18.03861,4.27014846 17.7218005,3.49267013 17.1996272,2.90063234 C16.6758829,3.49267013 16.3590734,4.27014846 16.3590734,5.12162162 L16.3590734,16.8783784 C16.3590734,19.6611259 14.1032108,21.9169884 11.3204633,21.9169884 C10.4023212,21.9169884 9.54153625,21.671413 8.80020941,21.2423631 C8.06022487,21.6715715 7.19969918,21.9169884 6.28185328,21.9169884 C3.57233599,21.9169884 1.36233773,19.7782932 1.24789843,17.0969428 L1.24324324,16.8783784 L1.24324324,8.48069498 C1.24324324,6.62552999 2.74715161,5.12162162 4.6023166,5.12162162 C6.39564276,5.12162162 7.86073912,6.52694044 7.95641962,8.29639203 L7.96138996,8.48069498 L7.96138996,16.8783784 C7.96138996,17.7298515 8.27819948,18.5073299 8.80037281,19.0993677 C9.32411712,18.5073299 9.64092664,17.7298515 9.64092664,16.8783784 L9.64092664,5.12162162 C9.64092664,2.33887414 11.8967892,0.083011583 14.6795367,0.083011583 C15.5976788,0.083011583 16.4584637,0.328586993 17.1997906,0.757636934 C17.9401369,0.32832539 18.8004937,0.083011583 19.7181467,0.083011583 C22.427664,0.083011583 24.6376623,2.22170676 24.7521016,4.90305718 L24.7567568,5.12162162 L24.7567568,13.519305 C24.7567568,15.37447 23.2528484,16.8783784 21.3976834,16.8783784 C19.6043572,16.8783784 18.1392609,15.4730596 18.0435804,13.703608 L18.03861,13.519305 L18.03861,5.12162162 Z M4.6023166,6.8011583 C3.67473411,6.8011583 2.92277992,7.55311249 2.92277992,8.48069498 L2.92277992,16.8783784 C2.92277992,18.7335434 4.42668829,20.2374517 6.28185328,20.2374517 C6.67462357,20.2374517 7.05164907,20.1700403 7.40199107,20.0461562 C6.74402575,19.2330567 6.33409518,18.2119151 6.28650847,17.0969428 L6.28185328,16.8783784 L6.28185328,8.48069498 C6.28185328,7.55311249 5.5298991,6.8011583 4.6023166,6.8011583 Z"></path>
    </svg>
  )
}

const dashAnimation = keyframes`
  from {
    stroke-dashoffset: 0;
  }
  to {
    stroke-dashoffset: 130;
  }
`

const styles = {
  icon: css`
    width: 25px;
    height: 25px;
    pointer-events: none;
  `,
  path: css`
    fill: none;
    stroke-width: 1;
    stroke-dasharray: 130;
    animation: ${dashAnimation} 1.5s infinite alternate ${transitionEasing};
  `
}
